import { createAction } from "redux-actions";
import { CLEAR_NOTIFICATION, NOTIFICATION } from "./types";

const notificationAction = createAction(NOTIFICATION);
const clearNotificationAction = createAction(CLEAR_NOTIFICATION);

export const saveNotification = (data) => (dispatch) => {
  dispatch(notificationAction(data));
};

export const clearNotification = () => (dispatch) => {
  dispatch(clearNotificationAction());
};
